import {HTTP} from '../../http'

import Vue from 'vue'
import Vuex from 'vuex'

import Common from '../../store/common'

Vue.use(Vuex)

export default new Vuex.Store({
  actions: {
    login: async (_, payload) => {
      try {
        const params = new URLSearchParams()
        params.append('login', payload.username)
        params.append('pass', payload.pass)
        params.append('application', 'sakura')
        const res = await HTTP.post('login', params)
        localStorage.setItem('so_token', res.data.token_type + ' ' + res.data.access_token)
        localStorage.setItem('so_token_expires', res.data.expires_in)
        return res
      } catch (e) {
        return e.response
      }
    }
  },
  modules: {
    common: Common,
  }
})
